import { Controller } from "@hotwired/stimulus"
import { Tab } from "bootstrap"

// Keeps the active tab sticky across save-and-continue round trips and
// syncs the URL hash so the tab is bookmarkable.
export default class extends Controller {
  static values = { storageKey: { type: String, default: "ws-editor-tab" } }

  connect() {
    this.restoreFromHashOrStorage()
    this.element.addEventListener("shown.bs.tab", this.onTabShown)
    const form = this.element.querySelector("form")
    if (form) {
      form.addEventListener("submit", this.onSubmit)
      this.boundForm = form
    }
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.tab", this.onTabShown)
    if (this.boundForm) {
      this.boundForm.removeEventListener("submit", this.onSubmit)
    }
  }

  restoreFromHashOrStorage = () => {
    const fromHash = window.location.hash.replace(/^#/, "")
    const fromStorage = sessionStorage.getItem(this.storageKeyValue)
    const target = fromHash || fromStorage
    if (!target) return
    const btn = this.element.querySelector(`[data-bs-target="#${CSS.escape(target)}"]`)
    if (btn) Tab.getOrCreateInstance(btn).show()
  }

  onTabShown = (event) => {
    const id = event.target.getAttribute("data-bs-target")?.replace(/^#/, "")
    if (!id) return
    history.replaceState(null, "", `#${id}`)
  }

  onSubmit = () => {
    const active = this.element.querySelector(".ws-tab.active")
    const id = active?.getAttribute("data-bs-target")?.replace(/^#/, "")
    if (id) sessionStorage.setItem(this.storageKeyValue, id)
  }
}
